import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, NgZone } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators, FormControl, FormArray, ValidationErrors } from '@angular/forms';
import { Theft } from '../../../class/theft';
import { TheftService } from '../../../service/theft/theft.service';
import { TranslateService } from '@ngx-translate/core';
import { SelectItem, MultiSelectModule, AutoCompleteModule, CalendarModule, Message } from 'primeng/primeng';
import { NotificationsService } from '../../../../../theme/services/notifications/notifications.service';
import { InspectionEquipment } from '../../../class/inspection-equipment';
import { InspectionEquipmentService } from '../../../service/inspection-equipment/inspection-equipment.service';
import { config } from '../../../../../../environments/config';
import { id } from '@swimlane/ngx-charts/release/utils';
import { UploadFilesService } from '../../../service/upload-files/upload-files.service';
import { Station } from '../../../class/station';
import { calendarES } from '../../../../../theme/functions/calendarES';

@Component({
  selector: 'app-new-theft',
  templateUrl: './new-theft.component.html',
  styleUrls: ['./new-theft.component.scss']
})
export class NewTheftComponent implements OnInit {
    @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() edit: Theft;
    @Output() reload: EventEmitter<number> = new EventEmitter<number>();
    public promiseForm: Promise<any>;
    public form: FormGroup;
    public save_exit: boolean;
    public es: any;

    public station_id: AbstractControl;
    public person_who_reports_id: AbstractControl;
    public city: AbstractControl;
    public visit_frequency: AbstractControl;
    public last_visit: AbstractControl;
    public type_responsibility_report: AbstractControl;
    public type_of_closure: AbstractControl;
    public state_closure: AbstractControl;
    public security_system_sse: AbstractControl;
    public damages_sse: AbstractControl;
    public power_plant: AbstractControl;
    public electric_plant_assurance: AbstractControl;
    public type_assurance_power_plant: AbstractControl;
    public has_batteries: AbstractControl;
    public battery_assurance: AbstractControl;
    public battery_belay_type: AbstractControl;
    public access_road: AbstractControl;
    public nearby_neighbors: AbstractControl;
    public distance_station: AbstractControl;
    public nearest_population: AbstractControl;
    public access_conditions_station: AbstractControl;
    public police_contact: AbstractControl;
    public theft_history: AbstractControl;
    public when_were_thefts: AbstractControl;
    public violently: AbstractControl;
    public cameras_close: AbstractControl;
    public discovery_date: AbstractControl;
    public last_visit_date: AbstractControl;
    public stolen_equipment_detail: AbstractControl;
    public additional_information: AbstractControl;
    public affects_service: AbstractControl;
    public affects_service_description: AbstractControl;
    public people_last_visits: AbstractControl;
    public city_analyst_security: AbstractControl;
    public email_analyst_security: AbstractControl;
    public name_analyst_security: AbstractControl;
    public mobile_analyst_security: AbstractControl;

    public employeePositionToLoadPersonWhoReports: string;

    public theftHasEquipments: any[];
    public newTheftHasEquipments: boolean;

    public equipments: InspectionEquipment[];
    public totalRecordsEquipments: number;
    public page: number;
    public per_page: number;
    public sort: string;

    public inspection_equipment_id: Array<number>;
    public trademark: FormArray;
    public model: FormArray;
    public state: FormArray;
    public type: FormArray;
    public capacity: FormArray;
    public serial: FormArray;
    public observations: FormArray;

    public uploadedFileLocationStation: any[] = [];
    public prewiewFileLocationStation: any;
    public promiseFileLocationStation: Promise<any>;
    public apiUrl = config.API_ROOT;



    public stateOptions: SelectItem[];

    public selectedTheftHasEquipment: any;
    public modAddTheftHasEquimentsDialog: boolean;
    public form5: FormGroup;
    public f5_type: AbstractControl;
    public f5_quantity: AbstractControl;
    public f5_state: AbstractControl;

    public uploadedFileEquipments: any[] = [];
    public prewiewFileEquipments: any;
    public promiseFileEquipments: Promise<any>;
    public msgs: Message[];

    constructor(
        fb: FormBuilder,
        public theftService: TheftService,
        public inspectionEquipmentService: InspectionEquipmentService,
        public translate: TranslateService,
        private notificationsService: NotificationsService,
        public uploadFilesService: UploadFilesService,
        private ngZone: NgZone) {

        this.equipments = [];
        this.inspection_equipment_id = [];
        this.employeePositionToLoadPersonWhoReports = '2';

        this.theftHasEquipments = [];

        this.modAddTheftHasEquimentsDialog = false;
        this.form5 = fb.group({
            'f5_type': ['', [Validators.required]],
            'f5_quantity': ['', [Validators.required]],
            'f5_state': ['', [Validators.required]],
        });
        this.f5_type = this.form5.controls['f5_type'];
        this.f5_quantity = this.form5.controls['f5_quantity'];
        this.f5_state = this.form5.controls['f5_state'];

        this.es = calendarES();

        this.stateOptions = [
            {label: 'choose', value: ''},
            {label: 'Robado', value: 'Robado'},
            {label: 'Dañado', value: 'Dañado'},
        ];

        this.save_exit = false;

        this.form = fb.group({
          'station_id': ['', Validators.compose([Validators.required, Validators.minLength(1)])],
          'person_who_reports_id': ['', Validators.compose([Validators.required, Validators.minLength(1)])],
          'city': ['', Validators.compose([Validators.required, Validators.minLength(1)])],
          'visit_frequency': ['', Validators.compose([Validators.required, Validators.minLength(1)])],
          'last_visit': ['', Validators.compose([Validators.required, Validators.minLength(1)])],
          'type_responsibility_report': ['', Validators.compose([Validators.required, Validators.minLength(1)])],
          'type_of_closure': ['', Validators.compose([Validators.required, Validators.minLength(1)])],
          'state_closure': ['', Validators.compose([Validators.required, Validators.minLength(1)])],
          'security_system_sse': [''],
          'damages_sse': [''],
          'power_plant': [''],
          'electric_plant_assurance': [''],
          'type_assurance_power_plant': [''],
          'has_batteries': [''],
          'battery_assurance': [''],
          'battery_belay_type': ['', Validators.compose([Validators.required, Validators.minLength(1)])],
          'access_road': ['', Validators.compose([Validators.required, Validators.minLength(1)])],
          'nearby_neighbors': [''],
          'distance_station': ['', Validators.compose([Validators.required, Validators.minLength(1)])],
          'nearest_population': ['', Validators.compose([Validators.required, Validators.minLength(1)])],
          'access_conditions_station': ['', Validators.compose([Validators.required, Validators.minLength(1)])],
          'police_contact': ['', Validators.compose([Validators.required, Validators.minLength(1)])],
          'theft_history': [''],
          'when_were_thefts': [''],
          'violently': [''],
          'cameras_close': [''],
          'discovery_date': ['', Validators.compose([Validators.required, Validators.minLength(1)])],
          'last_visit_date': [''],
          'stolen_equipment_detail': [''],
          'additional_information': [''],
          'affects_service': [''],
          'affects_service_description': [''],
          'people_last_visits': [''],
          'city_analyst_security': [''],
          'email_analyst_security': [''],
          'name_analyst_security': [''],
          'mobile_analyst_security': [''],


        });
        this.station_id = this.form.controls['station_id'];
        this.person_who_reports_id = this.form.controls['person_who_reports_id'];
        this.city = this.form.controls['city'];
        this.visit_frequency = this.form.controls['visit_frequency'];
        this.last_visit = this.form.controls['last_visit'];
        this.type_responsibility_report = this.form.controls['type_responsibility_report'];
        this.type_of_closure = this.form.controls['type_of_closure'];
        this.state_closure = this.form.controls['state_closure'];
        this.security_system_sse = this.form.controls['security_system_sse'];
        this.damages_sse = this.form.controls['damages_sse'];
        this.power_plant = this.form.controls['power_plant'];
        this.electric_plant_assurance = this.form.controls['electric_plant_assurance'];
        this.type_assurance_power_plant = this.form.controls['type_assurance_power_plant'];
        this.has_batteries = this.form.controls['has_batteries'];
        this.battery_assurance = this.form.controls['battery_assurance'];
        this.battery_belay_type = this.form.controls['battery_belay_type'];
        this.access_road = this.form.controls['access_road'];
        this.nearby_neighbors = this.form.controls['nearby_neighbors'];
        this.distance_station = this.form.controls['distance_station'];
        this.nearest_population = this.form.controls['nearest_population'];
        this.access_conditions_station = this.form.controls['access_conditions_station'];
        this.police_contact = this.form.controls['police_contact'];
        this.theft_history = this.form.controls['theft_history'];
        this.when_were_thefts = this.form.controls['when_were_thefts'];
        this.violently = this.form.controls['violently'];
        this.cameras_close = this.form.controls['cameras_close'];
        this.discovery_date = this.form.controls['discovery_date'];
        this.last_visit_date = this.form.controls['last_visit_date'];
        this.stolen_equipment_detail = this.form.controls['stolen_equipment_detail'];
        this.additional_information = this.form.controls['additional_information'];
        this.affects_service = this.form.controls['affects_service'];
        this.affects_service_description = this.form.controls['affects_service_description'];
        this.people_last_visits = this.form.controls['people_last_visits'];
        this.city_analyst_security = this.form.controls['city_analyst_security'];
        this.email_analyst_security = this.form.controls['email_analyst_security'];
        this.name_analyst_security = this.form.controls['name_analyst_security'];
        this.mobile_analyst_security = this.form.controls['mobile_analyst_security'];


        this.trademark = new FormArray([]);
        this.model = new FormArray([]);
        this.state = new FormArray([]);
        this.type = new FormArray([]);
        this.capacity = new FormArray([]);
        this.serial = new FormArray([]);
        this.observations = new FormArray([]);
    }

    ngOnInit() {

        this.page = 1;
        this.per_page = 10;

        if (this.edit) {
          this.station_id.setValue(this.edit.station_id);
          this.person_who_reports_id.setValue(this.edit.person_who_reports_id);
          this.city.setValue(this.edit.city);
          this.visit_frequency.setValue(this.edit.visit_frequency);
          this.last_visit.setValue(new Date(this.edit.last_visit));
          this.type_responsibility_report.setValue(this.edit.type_responsibility_report);
          this.type_of_closure.setValue(this.edit.type_of_closure);
          this.state_closure.setValue(this.edit.state_closure);
          this.security_system_sse.setValue(this.edit.security_system_sse);
          this.damages_sse.setValue(this.edit.damages_sse);
          this.power_plant.setValue(this.edit.power_plant);
          this.electric_plant_assurance.setValue(this.edit.electric_plant_assurance);
          this.type_assurance_power_plant.setValue(this.edit.type_assurance_power_plant);
          this.has_batteries.setValue(this.edit.has_batteries);
          this.battery_assurance.setValue(this.edit.battery_assurance);
          this.battery_belay_type.setValue(this.edit.battery_belay_type);
          this.access_road.setValue(this.edit.access_road);
          this.nearby_neighbors.setValue(this.edit.nearby_neighbors);
          this.distance_station.setValue(this.edit.distance_station);
          this.nearest_population.setValue(this.edit.nearest_population);
          this.access_conditions_station.setValue(this.edit.access_conditions_station);
          this.police_contact.setValue(this.edit.police_contact);
          this.theft_history.setValue(this.edit.theft_history);
          this.when_were_thefts.setValue(this.edit.when_were_thefts);
          this.violently.setValue(this.edit.violently);
          this.cameras_close.setValue(this.edit.cameras_close);
          if (this.edit.discovery_date) {
            this.discovery_date.setValue(new Date(this.edit.discovery_date));
          }
          if (this.edit.last_visit_date) {
            this.last_visit_date.setValue(new Date(this.edit.last_visit_date));
          }
          this.stolen_equipment_detail.setValue(this.edit.stolen_equipment_detail);
          this.additional_information.setValue(this.edit.additional_information);
          this.affects_service.setValue(this.edit.affects_service);
          this.affects_service_description.setValue(this.edit.affects_service_description);
          this.people_last_visits.setValue(this.edit.people_last_visits);
          if (this.edit.file_location_station) {
              this.uploadedFileLocationStation = [];
              this.uploadedFileLocationStation.push({'name': 'Archivo Adjunto  '});
          }
          if (this.edit.theft_has_equipment) {
              this.theftHasEquipments = this.edit.theft_has_equipment;
          }
          this.city_analyst_security.setValue(this.edit.city_analyst_security);
          this.email_analyst_security.setValue(this.edit.email_analyst_security);
          this.name_analyst_security.setValue(this.edit.name_analyst_security);
          this.mobile_analyst_security.setValue(this.edit.mobile_analyst_security);
        } else {
          this.security_system_sse.setValue(false);
          this.damages_sse.setValue(false);
          this.power_plant.setValue(false);
          this.electric_plant_assurance.setValue(false);
          this.has_batteries.setValue(false);
          this.battery_assurance.setValue(false);
          this.nearby_neighbors.setValue(false);
          this.theft_history.setValue(false);
          this.violently.setValue(false);
          this.cameras_close.setValue(false);
          this.affects_service.setValue(false);
        }
    }

    public cancelTheft () {
        console.log('reset');
        this.form.reset();
        this.close.emit(true);
    }

    public saveandexit (values){
        this.save_exit = true;
        this.newTheft(values);
    }

    public newTheft(values) {
        let item = [];
        this.theftHasEquipments.forEach(element => {
            item.push(
                {
                    'state': element.state,
                    'quantity': element.quantity,
                    'inspection_equipment_id': element.inspection_equipment_id
                }
            );
        });

        const param = {
        'station_id': values.station_id.id,
        'person_who_reports_id': values.person_who_reports_id.id,
        'city': values.city,
        'visit_frequency': values.visit_frequency,
        'last_visit': values.last_visit,
        'type_responsibility_report': values.type_responsibility_report,
        'type_of_closure': values.type_of_closure,
        'state_closure': values.state_closure,
        'security_system_sse': values.security_system_sse,
        'damages_sse': values.damages_sse,
        'power_plant': values.power_plant,
        'electric_plant_assurance': values.electric_plant_assurance,
        'type_assurance_power_plant': values.type_assurance_power_plant,
        'has_batteries': values.has_batteries,
        'battery_assurance': values.battery_assurance,
        'battery_belay_type': values.battery_belay_type,
        'access_road': values.access_road,
        'nearby_neighbors': values.nearby_neighbors,
        'distance_station': values.distance_station,
        'nearest_population': values.nearest_population,
        'access_conditions_station': values.access_conditions_station,
        'police_contact': values.police_contact,
        'theft_history': values.theft_history,
        'when_were_thefts': values.when_were_thefts,
        'violently': values.violently,
        'cameras_close': values.cameras_close,
        'discovery_date': values.discovery_date,
        'last_visit_date': values.last_visit_date,
        'stolen_equipment_detail': values.stolen_equipment_detail,
        'additional_information': values.additional_information,
        'affects_service': values.affects_service,
        'affects_service_description': values.affects_service_description,
        'people_last_visits': values.people_last_visits,
        'city_analyst_security': values.city_analyst_security,
        'email_analyst_security': values.email_analyst_security,
        'name_analyst_security': values.name_analyst_security,
        'mobile_analyst_security': values.mobile_analyst_security,
        'theft_has_equipments': item,
      };

      if (values && this.form.valid) {
          const promise = (this.edit) ?
              this.theftService.updateTheft(this.edit.id, param)
              :
              this.theftService.newTheft(param);

          this.promiseForm = promise.toPromise().then(
              response => {
                  this.translate.get('saved').subscribe((res: string) => {
                      this.notificationsService.growlNotify('success', res);
                      if (this.save_exit) {
                          this.close.emit(true);
                          this.form.reset();
                          this.save_exit = false;
                      } else {
                        this.edit = response.json();
                        this.reload.emit(response.json().id);
                        this.getTheftId(this.edit.id);
                      }
                  });
              },
              error => {
                  let msg = '';
                  this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
                      this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
                          JSON.parse(error._body).errors.forEach(element => {
                              if (element.source) {
                                  if (element.source.pointer) {
                                      this.translate.get(element.source.pointer).subscribe((res3: string) => {
                                          msg = msg + res3 + ', ';
                                      });
                                  }
                              }
                          });
                          this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
                          // this.msg.emit( { severity: 'error', summary: 'Error' } );
                      });
                  });
              }
          );
      }
  }

    // public newTheft(values: Theft) {
    //     let item = [];
    //     let i = 0;
    //     this.trademark.value.forEach(element => {
    //         item.push(
    //             {'trademark': this.trademark.value[i],
    //             'model': this.model.value[i],
    //             'state': this.state.value[i],
    //             'type': this.type.value[i],
    //             'capacity': this.capacity.value[i],
    //             'serial': this.serial.value[i],
    //             'observations': this.observations.value[i],
    //             'inspection_equipment_id': this.inspection_equipment_id[i]}
    //         );
    //         i++;
    //     });

    //     const param = {
    //       'station_id': values.station_id.id,
    //       'person_who_reports_id': values.person_who_reports_id,
    //       'city': values.city,
    //       'visit_frequency': values.visit_frequency,
    //       'last_visit': values.last_visit,
    //       'type_responsibility_report': values.type_responsibility_report,
    //       'type_of_closure': values.type_of_closure,
    //       'state_closure': values.state_closure,
    //       'security_system_sse': values.security_system_sse,
    //       'damages_sse': values.damages_sse,
    //       'power_plant': values.power_plant,
    //       'electric_plant_assurance': values.electric_plant_assurance,
    //       'type_assurance_power_plant': values.type_assurance_power_plant,
    //       'has_batteries': values.has_batteries,
    //       'battery_assurance': values.battery_assurance,
    //       'battery_belay_type': values.battery_belay_type,
    //       'access_road': values.access_road,
    //       'nearby_neighbors': values.nearby_neighbors,
    //       'distance_station': values.distance_station,
    //       'nearest_population': values.nearest_population,
    //       'access_conditions_station': values.access_conditions_station,
    //       'police_contact': values.police_contact,
    //       'theft_history': values.theft_history,
    //       'when_were_thefts': values.when_were_thefts,
    //       'violently': values.violently,
    //       'cameras_close': values.cameras_close,
    //       'discovery_date': values.discovery_date,
    //       'last_visit_date': values.last_visit_date,
    //       'stolen_equipment_detail': values.stolen_equipment_detail,
    //       'additional_information': values.additional_information,
    //       'affects_service': values.affects_service,
    //       'affects_service_description': values.affects_service_description,
    //       'people_last_visits': values.people_last_visits,
    //       'city_analyst_security': values.city_analyst_security,
    //       'email_analyst_security': values.email_analyst_security,
    //       'name_analyst_security': values.name_analyst_security,
    //       'mobile_analyst_security': values.mobile_analyst_security,

    //       'inspection_has_equipments': item,
    //       };
    //     if (values && this.form.valid) {
    //         const promise = (this.edit) ?
    //             this.theftService.updateTheft(this.edit.id, param)
    //             :
    //             this.theftService.newTheft(param);

    //         this.promiseForm = promise.toPromise().then(
    //             response => {
    //                 this.translate.get('saved').subscribe((res: string) => {
    //                     this.notificationsService.growlNotify('success', res);
    //                     // this.msg.emit( { severity: 'success', summary: res  } );
    //                     if (this.save_exit) {
    //                         this.close.emit(true);
    //                         this.form.reset();
    //                         this.save_exit = false;
    //                     }
    //                 });
    //             },
    //             error => {
    //                 let msg = '';
    //                 this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
    //                     this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
    //                         JSON.parse(error._body).errors.forEach(element => {
    //                             if (element.source) {
    //                                 if (element.source.pointer) {
    //                                     this.translate.get(element.source.pointer).subscribe((res3: string) => {
    //                                         msg = msg + res3 + ', ';
    //                                     });
    //                                 }
    //                             }
    //                         });
    //                         this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
    //                         // this.msg.emit( { severity: 'error', summary: 'Error' } );
    //                     });
    //                 });
    //             }
    //         );
    //     }
    // }


    public onUploadFileLocationStation(event: any) {
      this.uploadedFileLocationStation = [];
      for (const file of event.srcElement.files) {
          this.uploadedFileLocationStation.push(file);
      }
      if (event.target.files && event.target.files[0]) {
          const reader = new FileReader();
          reader.onload = () => {
            this.prewiewFileLocationStation = reader.result;
          };
          reader.readAsDataURL(event.target.files[0]);
      }
    }

    public updateFileLocationStation(event: any) {
        let msg = '';
        this.translate.get('uploading').subscribe((res: string) => {
            this.notificationsService.growlNotify('info', res + '...');
        });
        this.uploadedFileLocationStation = [];
        for (const file of event.files) {
            this.uploadedFileLocationStation.push(file);
        }

        this.promiseFileLocationStation = this.uploadFilesService.updateFileLocationStation(this.uploadedFileLocationStation, this.edit.id).toPromise().then(
            response => {
                this.translate.get('saved').subscribe((res: string) => {
                  this.notificationsService.growlNotify('success', res);
                });
                // this.getProfile();
                // this.avatar = this.prewiewFileLocationStation;
            },
            error => {
              let msg = '';
              this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
                  this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
                      JSON.parse(error._body).errors.forEach(element => {
                          if (element.source) {
                              if (element.source.pointer) {
                                  this.translate.get(element.source.pointer).subscribe((res3: string) => {
                                      msg = msg + res3 + ', ';
                                  });
                              }
                          }
                      });
                      this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
                      // this.msg.emit( { severity: 'error', summary: 'Error' } );
                  });
              });
          }
        );
    }

    public gotoFileLocationStation() {
      window.open(this.apiUrl + '/thefts/' + this.edit.id + '/file-location-station' + '?token=' + localStorage.getItem('token'), '_blank');
    }

//     public formatDate(date) {
//       const d = new Date(date);
//       let month = '' + (d.getMonth() + 1);
//       let day = '' + d.getDate();
//       const year = d.getFullYear();
//       let hours = '' + d.getHours();
//       let minutes = '' + d.getMinutes();
//       let seconds = '' + d.getSeconds();

//       if (month.length < 2) {
//           month = '0' + month;
//       }
//       if (day.length < 2) {
//           day = '0' + day;
//       }

//       if (hours.length < 2) {
//           hours = '0' + hours;
//       }

//       if (minutes.length < 2) {
//           minutes = '0' + minutes;
//       }

//       if (seconds.length < 2) {
//           seconds = '0' + seconds;
//       }

//       return [year, month, day].join('-');
//   }

  public findElement (list, search) {
    let find = -1;
    let itera = 0;
    list.forEach(element => {
        if (element.inspection_equipment_id === search) {
            find = itera;
        }
        itera++;
    });
    return find;
  }

  getFormValidationErrors(form) {
    let value = '';
    Object.keys(form.controls).forEach(key => {
        const controlErrors: ValidationErrors = this.form.get(key).errors;
        if (controlErrors != null) {
            Object.keys(controlErrors).forEach(keyError => {
                value = 'Key control: ' + key + ', keyError: ' + keyError + ', err value: ' + controlErrors[keyError];
            });
        }
    });
    return (value);
  }

    public showAddTheftHasEquimentsDialog() {
        this.newTheftHasEquipments = true;
        this.modAddTheftHasEquimentsDialog = true;
    }

    public cancelAddTheftHasEquimentsDialog() {
        this.modAddTheftHasEquimentsDialog = false;
    }

    public addTheftHasEquiments(values) {
        let the = [...this.theftHasEquipments];
        if(this.newTheftHasEquipments)
            the.push({'type':values.f5_type, 'quantity':values.f5_quantity, 'state':values.f5_state, 'inspection_equipment_id': values.f5_type.id, 'inspection_equipment': values.f5_type});
        else
            the[this.findSelectedIndex()] = {'type':values.f5_type, 'quantity':values.f5_quantity, 'state':values.f5_state, 'inspection_equipment_id': values.f5_type.id, 'inspection_equipment': values.f5_type};

        this.theftHasEquipments = the;
        this.form5.reset();
    }

    findSelectedIndex(): number {
        return this.theftHasEquipments.indexOf(this.selectedTheftHasEquipment);
    }

    onRowSelectTheftHasEquiments(event) {
        this.newTheftHasEquipments = false;
        console.log(event);
        this.modAddTheftHasEquimentsDialog = true;
    }

    public onUploadFileEquipment(event: any, id) {
    }

    public updateFileEquipment(event: any, id) {
        this.translate.get('uploading').subscribe((res: string) => {
            this.notificationsService.growlNotify('info', res + '...');
        });

        for (const file of event.files) {
            this.uploadedFileEquipments[id]=file;
        }

        this.promiseFileEquipments = this.uploadFilesService.updateTheftFileEquipment(this.uploadedFileEquipments[id], id).toPromise().then(
            response => {
                this.translate.get('saved').subscribe((res: string) => {
                    this.notificationsService.growlNotify('success', res);
                });
                this.getTheftId(this.edit.id);
            },
            error => {
                let msg = '';
                this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
                    this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
                        JSON.parse(error._body).errors.forEach(element => {
                            if (element.source) {
                                if (element.source.pointer) {
                                    this.translate.get(element.source.pointer).subscribe((res3: string) => {
                                        msg = msg + res3 + ', ';
                                    });
                                }
                            }
                        });
                        this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
                    });
                });
            }
        );
    }

    public gotoFileEquipment(id) {
      window.open(this.apiUrl + '/theft-has-equipments/' + id + '/file-evidence'  + '?token=' + localStorage.getItem('token'), '_blank');
    }

    public getTheftId(id) {
        this.theftService.infoTheft(id).toPromise().then(
        response => {
            let aux = response.json().data[0];
            let the = [...this.theftHasEquipments];
            the = aux.theft_has_equipment;
            this.theftHasEquipments = the;
            this.edit = response.json().data[0];
        },
        error => {
            let msg = '';
            this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
                this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
                    JSON.parse(error._body).errors.forEach(element => {
                        if (element.source) {
                            if (element.source.pointer) {
                                this.translate.get(element.source.pointer).subscribe((res3: string) => {
                                    msg = msg + res3 + ', ';
                                });
                            }
                        }
                    });
                    this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
                    // this.msg.emit( { severity: 'error', summary: 'Error' } );
                });
            });
        }
    );
    }

    public checkOtherValidation (values) {
        let check = false;
        if (values) {
            if (values.candidate_id) {
                if (values.candidate_id.id) {
                    check = true;
                } else {
                    return false;
                }
            }
        }
        return check;
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/thefts/new-theft/new-theft.component.ts